import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '../../assets/images/404.svg'


const _hoisted_1 = { class: "flex flex-col justify-center items-center h-screen gap-4 p-2" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "404-img",
  class: "w-100 h-64"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "text-xl font-bold" }, "Erro 404", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("p", { class: "text-gray-700 text-center w-100 md:w-2/6" }, " Ops! Parece que a página que você está procurando não existe, sentimos muito por isso. ", -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}